import { getCards } from "@/common/service/cardService";

export default {
  namespaced: true,

  // initial state
  state: {
    cards: []
  },

  //mutations
  mutations: {
    setCards(state, cards) {
      state.cards = cards;
    }
  },

  //actions
  actions: {
    async loadCards({ commit, dispatch }) {
      dispatch("error/setError", null, { root: true });
      try {
        const cards = await getCards();
        commit("setCards", cards);
      } catch (error) {
        dispatch("error/setError", error, { root: true });
      }
    }
  },

  //getters
  getters: {
    cardsData: state => state.cards.cards
  }
};
